import Marquee from "react-fast-marquee";

const ITEMS = [
  "Locum ANP",
  "GP Locum",
  "Primary Care Locum",
  "Face-to-Face Locum Clinics",
  "Remote Clinical Triage",
  "Clinical Workflow Systems",
  "Blood Results Actioned",
  "Medication Requests",
  "UK GP Surgeries",
  "Staff Shortage Cover",
];

export default function Ribbon() {
  return (
    <section className="bg-surface-alt border-y border-[#dedcd2] py-5" data-testid="ribbon-section">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-mono-label text-sm uppercase tracking-[0.22em] text-forest-accent">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-sage" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
